import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Back-in-stock link; syncs selected variant id for Amp Back in Stock.
 * Amp handles opens via .BIS_trigger — do not proxy clicks (that toggles the modal shut).
 *
 * @typedef {object} BackInStockTriggerRefs
 * @property {HTMLButtonElement} trigger - The notify trigger button.
 */

/**
 * @extends {Component<BackInStockTriggerRefs>}
 */
class BackInStockTrigger extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const variant = event.detail.resource;
    const { trigger } = this.refs;

    if (!trigger || !variant?.id) return;

    trigger.dataset.variantId = String(variant.id);
  };
}

if (!customElements.get('back-in-stock-trigger')) {
  customElements.define('back-in-stock-trigger', BackInStockTrigger);
}
